import React, { useState, useEffect } from 'react';
import { listSupportTeamList } from '../../services/StudentHubService';

function StudentSupport(props) {
    const [copyText, setCopyText] = useState([0, 0, 0]);
    const [copyText1, setCopyText1] = useState([0, 0, 0]);
    const [data, setData] = useState([]);

    const copyEmailText = (email, i) => {
        navigator.clipboard.writeText(email);
        let a = [0, 0, 0];
        let b = [0, 0, 0];
        a[i] = 1;
        setCopyText([...a]);
        setTimeout(() => {
            setCopyText([...b]);
        }, 1000);
    };

    const copyNumberText = (mobile, i) => {
        navigator.clipboard.writeText(mobile);
        let a = [0, 0, 0];
        let b = [0, 0, 0];
        a[i] = 1;

        setCopyText1([...a]);
        setTimeout(() => {
            setCopyText1([...b]);
        }, 1000);
    };

    const getSupportList = () => {
        listSupportTeamList()
            .then((res) => {
                if (res.status === 200) {
                    setData(res.data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        getSupportList();
    }, []);

    return (
        <>
            <div className="header-info-box">
                <h4>Have additional questions?</h4>
                <p>
                    Our team is available to help you with any academic-related queries through the{' '}
                    <b>Search Assistance</b> buttons on the sidebar.
                </p>

                <p>Alternatively, you can also ask for assistance in the relevant Programme/Course's Chatroom.</p>
            </div>
        </>
    );
}

export default StudentSupport;
